import { createSlice } from '@reduxjs/toolkit';
import { HTTP_GETTYPE, STATUS_API } from 'src/app/constant/config';
import AxiosAdapter from './AxiosAdapter';
import { MESSAGE } from 'src/app/constant/message';

export const getListVehicleTypes = AxiosAdapter.GetHttp(
  'vehicleTypeSlice/getListVehicleTypes',
  '/vehicle_type',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createVehicleType = AxiosAdapter.HttpPost(
    'vehicleTypeSlice/createVehicleType',
    '/vehicle_type',
    MESSAGE.CREATE_VEHICLETYPE_SUCCESS,
    'Tạo mới loại phương tiện thất bại'
)

export const updateVehicleType = AxiosAdapter.HttpUpdateById(
  'vehicleTypeSlice/updateVehicleType',
  '/vehicle_type',
  MESSAGE.UPDATE_VEHICLETYPE_SUCCESS,
  'Cập nhật loại phương tiện thất bại'
)

export const deleteVehicleType = AxiosAdapter.HttpDelete(
    'vehicleTypeSlice/deleteVehicleType',
    'vehicle_type',
    MESSAGE.DELETE_VEHICLETYPE_SUCCESS,
    'Xóa loại phương tiện thất bại'
)

export const deleteMultiVehicleType = AxiosAdapter.HttpDeleteMulti(
    'vehicleTypeSlice/deleteMultiVehicleType',
    'vehicle_type',
    MESSAGE.DELETE_VEHICLETYPE_SUCCESS,
    'Xóa loại phương tiện thất bại'
)

export const vehicleTypeSlice = createSlice({
  name: 'vehicleTypeSlice',
  initialState: {
    listVehicleTypes: null,
    total: 0,
    error: null,
    statusGet: null,
    statusDelete: null, 
    statusMultiDelete: null, 
    statusCreate: null,
    statusUpdate: null,
    isLoading: false, 
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.isLoading = false;
      state.statusCreate = null;
      state.statusDelete = null;
      state.statusMultiDelete = null;
      state.statusUpdate = null;
    }
  },
  extraReducers: {
    [getListVehicleTypes.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListVehicleTypes.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listVehicleTypes = action.payload.payload.types
      state.total = action.payload.payload.number_of_item;
      state.isLoading = false;
    },
    [getListVehicleTypes.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createVehicleType.pending]: state => {
        state.statusCreate = STATUS_API.PENDING;
    },
    [createVehicleType.fulfilled]: (state, action) => {
        state.statusCreate = STATUS_API.SUCCESS;
    },
    [createVehicleType.rejected]: (state, action) => {
        state.statusCreate = STATUS_API.ERROR;
        state.error = action.payload.message || action.error;
    },
    [deleteVehicleType.pending]: state => {
        state.statusDelete = STATUS_API.PENDING;
    },
    [deleteVehicleType.fulfilled]: (state, action) => {
        state.statusDelete = STATUS_API.SUCCESS;
    },
    [deleteVehicleType.rejected]: (state, action) => {
        state.statusDelete = STATUS_API.ERROR;
        state.error = action.payload.message || action.error;
    },
    [deleteMultiVehicleType.pending]: state => {
        state.statusMultiDelete = STATUS_API.PENDING;
    },
    [deleteMultiVehicleType.fulfilled]: (state, action) => {
        state.statusMultiDelete = STATUS_API.SUCCESS;
    },
    [deleteMultiVehicleType.rejected]: (state, action) => {
        state.statusMultiDelete = STATUS_API.ERROR;
        state.error = action.payload.message || action.error;
    },
    [updateVehicleType.pending]: state => {
      state.statusUpdate = STATUS_API.PENDING;
    },
    [updateVehicleType.fulfilled]: (state, action) => {
      state.statusUpdate = STATUS_API.SUCCESS;
    },
    [updateVehicleType.rejected]: (state, action) => {
      state.statusUpdate = STATUS_API.ERROR;
      state.error = action.payload.message;
    }
  }
});
export const {
  resetChange,
} = vehicleTypeSlice.actions;

export default vehicleTypeSlice.reducer;
